import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import CustomSelectDropdown from "../../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown";
import CustomDatePicker from "../../../../../Components/custom_components/CustomDatePicker/CustomDatePicker";
import CustomTextFieldWithIcon from "../../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon";
import ActionButton from "../../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton";
import { get_report_status } from "../../../../../config/GeneralApis/GeneralApis";
import CustomTextArea from "../../../../../Components/custom_components/CustomTextArea/CustomTextArea";
import { convertToISO } from "../../../../../utils/formatDate";
import { get_workforce_with_pagination } from "../../../../../config/Resource/workforceApis";


const ReportAddForm = ({ handleSave, isButtonDisabled, scheduleId, isDisabled, defaultValues }) => {


    const [engineerOptions, setEngineerOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    // Report Form Validation Schema
    const ReportFormSchema = Yup.object().shape({
        status: Yup.string().required("Status is required"),

        start_date: Yup.string()
            .required('Start Date is required'),

        end_date: Yup.string()
            .required('End Date is required')
            .test(
                'end-date-after-start-date',
                'End date cannot be before start date',
                function (value) {
                    const { start_date } = this.parent;

                    const startDate = new Date(convertToISO(start_date) || '');
                    const endDate = new Date(convertToISO(value) || '');
                    return endDate >= startDate;
                }
            ),

        count: Yup.number()
            .typeError("Must be a number")
            .required("Number of reports is required")
            .min(1, "At least 1 report is required"),
        // assigned_id: Yup.array().min(1, "Select at least one engineer").required("Engineer is required"),

    });


    const formik = useFormik({
        initialValues: {
            status: 1,
            start_date: null,
            end_date: null,
            count: "",
            // assigned_id: [],
            shortDescription: "",
        },
        validationSchema: ReportFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            handleSave(values, scheduleId)
        },
    });

    // ENGINEERS
    // const fetchAvailableEngineers = async () => {
    //     try {
    //         // Prepare the params if needed. Adjust as per your API requirements.
    //         const params = {
    //             status: isDisabled ? '' : 1,
    //             start_date: defaultValues?.SD_Survey_from_date,
    //             end_date: defaultValues?.SD_Survey_end_date,
    //         }
    //         const response = await get_available_engineers(params);

    //         if (response?.status === "success") {
    //             // Transform data into the desired format with label and value
    //             const transformedData = response.data?.map((item) => ({
    //                 label: item?.EngineerName,
    //                 value: item?.id
    //             }));

    //             // Set the transformed data to the state
    //             setEngineerOptions(transformedData || []);
    //         } else {
    //             setEngineerOptions([]);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching available engineers:', error);
    //         setEngineerOptions([]);
    //     }
    // };


    // FETCH fetchWorkforce
    // const fetchWorkforce = async () => {
    //     try {
    //         const params = { //FOR GET ENGINEERS ONLY LIST
    //             RoleID: 5,
    //             status: 1
    //         }
    //         const response = await get_workforce_with_pagination(params);

    //         if (response?.status === "success") {
    //             // Transform data into the desired format with label and value
    //             const transformedData = response.data.data?.map((item) => ({
    //                 label: item?.UD_name,
    //                 value: item?.UD_ID
    //             }));

    //             // Set the transformed data to the state
    //             setEngineerOptions(transformedData || []);
    //         } else {
    //             setEngineerOptions([]);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching :', error);
    //         setEngineerOptions([]);
    //     }
    // };

    // REPOR STATAUS
    const fetchReportStatus = async () => {
        try {
            const response = await get_report_status();
            if (response?.status === "success") {
                const transformedData = response.data?.map(item => ({
                    label: item?.process,
                    value: item?.id,
                }));
                setStatusOptions(transformedData || []);
            } else {
                setStatusOptions([]);
            }
        } catch (error) {
            console.error("Error fetching report status:", error);
            setStatusOptions([]);
        }
    };

    useEffect(() => {
        fetchReportStatus();
    }, [isDisabled])

    useEffect(() => {
        // fetchWorkforce()
    }, [])
    // useEffect(() => {
    //     fetchAvailableEngineers();
    // }, [defaultValues, isDisabled])

    return (
        <div className="taskform-form-container">
            <Grid container columnSpacing={3}>
                {/* Process */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">
                                Process<span className="label_required_remark">*</span>
                            </span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomSelectDropdown
                                name="status"
                                placeholder="Select Status"
                                options={statusOptions}
                                value={
                                    statusOptions?.find(option => option?.value === formik?.values?.status) ||
                                    statusOptions?.find(option => option?.value == 1)
                                }
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                                isDisabled={true}
                                isMulti={false}
                                width="100%"
                            />
                        </div>
                    </div>
                </Grid>

                {/* Start Date */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">
                                Start Date<span className="label_required_remark">*</span>
                            </span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomDatePicker
                                name="start_date"
                                label="Start Date"
                                onChange={date => {
                                    formik.setFieldValue("start_date", date);
                                }}
                                onBlur={formik.handleBlur}
                                value={dayjs(formik.values.start_date, "DD-MM-YYYY")}
                                error={formik.touched.start_date && Boolean(formik.errors.start_date)}
                                helperText={formik.touched.start_date && formik.errors.start_date}
                                isDisabled={isDisabled}
                                minDate={dayjs()}
                            />
                        </div>
                    </div>
                </Grid>

                {/* End Date */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">
                                End Date<span className="label_required_remark">*</span>
                            </span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomDatePicker
                                name="end_date"
                                label="End Date"
                                onChange={date => {
                                    formik.setFieldValue("end_date", date);
                                }}
                                onBlur={formik.handleBlur}
                                value={dayjs(formik.values.end_date, "DD-MM-YYYY")}
                                error={formik.touched.end_date && Boolean(formik.errors.end_date)}
                                helperText={formik.touched.end_date && formik.errors.end_date}
                                isDisabled={isDisabled}
                                minDate={dayjs(formik.values.start_date, "DD-MM-YYYY")} // restrict to after or same as from date

                            />
                        </div>
                    </div>
                </Grid>

                {/* Count */}
                <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">
                                Number of Reports<span className="label_required_remark">*</span>
                            </span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomTextFieldWithIcon
                                id="count"
                                name="count"
                                placeholder="Enter number"
                                type="number"
                                value={formik.values.count}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.count && Boolean(formik.errors.count)}
                                helperText={formik.touched.count && formik.errors.count}
                                isDisabled={isDisabled}
                                maxLength={6}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Assigned Engineer */}
                {/* <Grid item xs={12} md={6}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">
                                Engineers<span className="label_required_remark">*</span>
                            </span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomSelectDropdown
                                name="assigned_id"
                                placeholder="Select Engineer(s)"
                                options={engineerOptions}
                                value={engineerOptions?.filter(option => formik.values.assigned_id?.includes(option.value))}
                                onChange={selectedOptions => {
                                    const selectedValues = selectedOptions.map(option => option.value);
                                    formik.setFieldValue("assigned_id", selectedValues);
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.assigned_id && Boolean(formik.errors.assigned_id)}
                                helperText={formik.touched.assigned_id && formik.errors.assigned_id}
                                isDisabled={isDisabled}
                                isMulti={true}
                                width="100%"
                                StartIcon={<GrUserWorker />}
                            />
                        </div>
                    </div>
                </Grid> */}

                {/* Description */}
                <Grid item xs={12}>
                    <div className="taskform-mid-form-container">
                        <div className="label-container">
                            <span className="label">
                                Description
                            </span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomTextArea
                                id="shortDescription"
                                name="shortDescription"
                                placeholder="Enter Description"
                                value={formik.values.shortDescription}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                rows={5}
                                isDisabled={isDisabled}
                                error={formik.touched.shortDescription && Boolean(formik.errors.shortDescription)}
                                helperText={formik.touched.shortDescription && formik.errors.shortDescription}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>

            {/* Action Buttons */}
            {!isDisabled && (
                <div className="form-bottom-action-buttons-container">
                    <ActionButton onClick={() => {
                        formik.resetForm();
                    }} label="Reset" btnType="outlined" />
                    <ActionButton
                        btnDisable={isButtonDisabled}
                        onClick={formik.handleSubmit}
                        label="Save"
                        btnType="primary"
                    />
                </div>
            )}
        </div>
    );
};

export default ReportAddForm;